/**
 * @module explore/components/creative_tile
 */
import React, { PropTypes } from 'react';
import { v4 } from 'node-uuid';
import ReputationChart from 'common/components/reputation_chart';
import { Link } from 'react-router';
import Avatar from 'common/components/avatar';
import Menu from 'explore/containers/creative_menu';
import Attribute from 'marketing/common/attribute';
import Tooltip from 'react-tooltip';
import Thumbnail from 'common/components/thumbnail';
import { isMobile } from 'common/utils';


/**
 * Component rendering single creative object
 * @author Kuba Siemiątkowski <kuba@crowdspring.com>
 */

const EmptyPorfolio = ({creative}) => (
  <div className="empty-portfolio">
    <div className="empty-portfolio-content">
      <h4>{creative.username} has been a bit slow creating their portfolio.</h4>
    </div>
    <img
        src="https://s3.amazonaws.com/crowdspring3-assets/marketing/crowdspring_explore_no-portfolio_lagrell-2x.png"
        alt="Indifferent Turtle by lagrell"
        className="empty-portfolio-image"
      />
      <Attribute to="lagrell"/>
  </div>
);

const CreativeTile = ({ creative }) => {

  const thumbnailImage1 = creative.portfolio_thumbnail_1;
  const thumbnailImage2 = creative.portfolio_thumbnail_2;
  const thumbnailImage3 = creative.portfolio_thumbnail_3;

  return (
    <div className="row" key={v4()}>
      <div className="small-16 column">
        <div className="tile creative-tile">
          <div className="row">
            <div className="small-16 columns">
              <div className="creative-header">
                <div className="row">
                  <div className="small-16 medium-6 columns">

                    <Link to={`/users/${creative.username}/`}>
                      <Avatar user={creative} extraClasses="avatar-sm" />
                    </Link>
                    <div className="creative-name">
                      <h2>
                        <Link to={`/users/${creative.username}/`}>
                          { creative.username }
                        </Link>
                      </h2>
                      <span className="creative-location">
                        { creative.country && <span>{ creative.country_full_name }</span> }
                      </span>
                    </div>
                  </div>
                  <div className="small-16 medium-4 columns">
                    <div className="creative-reputation">
                      {creative.is_elite && <span
                        className="tag tag-sm tag-highlight elite"
                        data-tip={true} data-for={`rep-tag-tooltip-${creative.id}`}
                        data-event={isMobile()? "click" : undefined}
                      >Elite</span>}
                      {creative.is_platinum && !creative.is_elite && <span
                        className="tag tag-sm tag-highlight platinum"
                        data-tip={true} data-for={`rep-tag-tooltip-${creative.id}`}
                        data-event={isMobile()? "click" : undefined}
                      >Platinum</span>}
                      <Tooltip class="tag-tooltip tooltip" effect="solid" place="right"
                          id={`rep-tag-tooltip-${creative.id}`}>
                        Platinum creatives have a reputation of 80-90,<br/>
                        while Elite creatives have a reputation of 90 to 100.<br/>
                        These are the best, most experienced creatives on<br/>
                        crowdspring, as measured by the quality of their work.
                      </Tooltip>
                      <ReputationChart containerClass="reputation-chart"
                        reputation={creative.reputation} withTooltip={true}/>
                    </div>
                  </div>
                  <div className="small-16 medium-6 columns">
                    <Menu creative={creative} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="creative-projects">
              { thumbnailImage1 && thumbnailImage2 && thumbnailImage3?
              <div className="small-16 column">
                <Link to={`/users/${creative.username}/portfolio/`}>
                  <div className="row collapse">
                    <div className="column">
                      <Thumbnail className="thumbnail flex" image={thumbnailImage1} />
                    </div>
                    <div className="show-for-medium column">
                      <Thumbnail className="thumbnail flex" image={thumbnailImage2} />
                    </div>
                    <div className="show-for-large column">
                      <Thumbnail className="thumbnail flex" image={thumbnailImage3} />
                    </div>
                  </div>
                </Link>
              </div>:
              <EmptyPorfolio creative={creative} />}
          </div>
        </div>
      </div>
    </div>
  );
};

CreativeTile.propTypes = {
  creative: PropTypes.object,
};

export default CreativeTile;



// WEBPACK FOOTER //
// ./explore/components/creative_tile.jsx